import {ConstraintBasedOptimizerBO} from "../PA.Simulation.BusinessObjects/ConstraintBasedOptimizerBO";
import {IMessageProvider, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {BehaviorSubject} from "rxjs";

export interface IHaveCBOCalculator {
    readonly CBOCalculator: ICBOCalculator
}

export interface ICBOCalculatorCalculateOptions {
}

export enum CBOSessionStatus {
    CalculationInitiated      = "CalculationInitiated",
    NotStarted                = "NotStarted",
    CreatingSimulations       = "CreatingSimulations",
    DoneCreatingSimulations   = "DoneCreatingSimulations",
    CalculatingSimulations    = "CalculatingSimulations",
    DoneCalculatingSimulation = "DoneCalculatingSimulation",
    WritingResultsToDatabase  = "WritingResultsToDatabase",
    Done                      = "Done"
}

export interface ICBOCalculatorDetailProgress {
    bRunning: boolean,
    CalculationStep: CBOSessionStatus
    NumberOfSimulationsCompleted: number,
    TotalNumberOfSimulations: number,
    ElapsedTimeInSeconds: number,
    EstimatedRemainingTimeInSeconds: number,
}

export interface ICBOCalculator {
    Register(cboBO: ConstraintBasedOptimizerBO): void
    UnRegister(): void
    readonly CBO: ConstraintBasedOptimizerBO

    readonly CalcProgressProvider: IProgressProvider
    readonly CalcMessageProvider: IMessageProvider

    Calculate(opts?: ICBOCalculatorCalculateOptions): Promise<void>
    readonly OnCalculateComplete: BehaviorSubject<ICBOCalculator>

    readonly DetailedProgress: ICBOCalculatorDetailProgress,
    readonly OnDetailedProgressChanged: BehaviorSubject<ICBOCalculator>

}



export interface ICBOServiceRequest {
    RequestType: string,
    wbCBOId: number,
    RequestOptions?: any
}

export interface ICBOServiceResponse {
    bSuccess: boolean,
    sWarnings: string[],
    sErrors: string[],
    NumberOfSimulationsCompleted?: number,
    TotalNumberOfSimulations?: number,
    ElapsedTimeInSeconds?: number,
    EstimatedRemainingTimeInSeconds?: number,
    Results?: string
}


export interface ICBOServiceCalculateScenarioOptions {
    wbAuthUsrId?: number
}

export interface ICBOService {

    CalculateCBO(wbCBOId: number, opts?: ICBOServiceCalculateScenarioOptions): Promise<ICBOServiceResponse>
    GetCBOStatus(wbCBOId: number, opts?: any): Promise<ICBOServiceResponse>
    StopCBO(wbCBOId: number, opts?: any): Promise<ICBOServiceResponse>

}
